/* Signal Peptide Interactions 2026 */
(function(){
'use strict';

// === SCROLL REVEAL ===
function initScrollReveal(){
  const els = document.querySelectorAll('.sp-fade-up');
  if(!els.length) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('sp-visible'); io.unobserve(e.target); } });
  },{threshold:0.12});
  els.forEach(el=>io.observe(el));
}

// === COUNTER ANIMATION ===
function animateCounter(el){
  const target = parseFloat(el.dataset.count);
  const suffix = el.dataset.suffix||'';
  const prefix = el.dataset.prefix||'';
  const duration = 1800;
  const start = performance.now();
  function tick(now){
    const t = Math.min((now-start)/duration, 1);
    const ease = 1 - Math.pow(1-t, 3);
    const val = target * ease;
    el.textContent = prefix + (Number.isInteger(target) ? Math.round(val).toLocaleString() : val.toFixed(1)) + suffix;
    if(t < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

function initCounters(){
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ animateCounter(e.target); io.unobserve(e.target); } });
  },{threshold:0.5});
  document.querySelectorAll('[data-count]').forEach(el=>io.observe(el));
}

// === FAQ ACCORDION ===
function initFAQ(){
  document.querySelectorAll('.sp-faq-q').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const item = btn.closest('.sp-faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.sp-faq-item.open').forEach(i=>i.classList.remove('open'));
      if(!wasOpen) item.classList.add('open');
    });
  });
}

// === FLOATING PARTICLES ===
function initParticles(){
  const canvas = document.getElementById('sp-particles');
  if(!canvas) return;
  const ctx = canvas.getContext('2d');
  let W = canvas.width = window.innerWidth;
  let H = canvas.height = window.innerHeight;
  const particles = Array.from({length:40},()=>({
    x: Math.random()*W, y: Math.random()*H,
    vx:(Math.random()-0.5)*0.3, vy:(Math.random()-0.5)*0.3,
    r: Math.random()*1.5+0.5,
    a: Math.random()
  }));
  function draw(){
    ctx.clearRect(0,0,W,H);
    particles.forEach(p=>{
      p.x += p.vx; p.y += p.vy;
      if(p.x<0||p.x>W) p.vx*=-1;
      if(p.y<0||p.y>H) p.vy*=-1;
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
      ctx.fillStyle = `rgba(0,212,255,${p.a*0.4})`;
      ctx.fill();
    });
    // draw lines between close particles
    for(let i=0;i<particles.length;i++){
      for(let j=i+1;j<particles.length;j++){
        const dx=particles[i].x-particles[j].x, dy=particles[i].y-particles[j].y;
        const d=Math.sqrt(dx*dx+dy*dy);
        if(d<120){
          ctx.beginPath();
          ctx.moveTo(particles[i].x,particles[i].y);
          ctx.lineTo(particles[j].x,particles[j].y);
          ctx.strokeStyle=`rgba(0,212,255,${(1-d/120)*0.08})`;
          ctx.stroke();
        }
      }
    }
    requestAnimationFrame(draw);
  }
  draw();
  window.addEventListener('resize',()=>{ W=canvas.width=window.innerWidth; H=canvas.height=window.innerHeight; });
}

// === SMOOTH HOVER TILT ===
function initTilt(){
  document.querySelectorAll('.sp-tilt').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      const r = card.getBoundingClientRect();
      const x = (e.clientX-r.left)/r.width - 0.5;
      const y = (e.clientY-r.top)/r.height - 0.5;
      card.style.transform = `translateY(-6px) rotateX(${-y*6}deg) rotateY(${x*6}deg)`;
    });
    card.addEventListener('mouseleave',()=>{ card.style.transform=''; });
  });
}

// === STICKY HEADER SHRINK ===
function initStickyHeader(){
  let last=0;
  window.addEventListener('scroll',()=>{
    const y=window.scrollY;
    const header=document.querySelector('#header-component');
    if(!header) return;
    if(y>80) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
    last=y;
  },{passive:true});
}

// === QUICK ADD ===
function initQuickAdd(){
  document.querySelectorAll('.sp-quick-add[data-variant]').forEach(btn=>{
    btn.addEventListener('click',async e=>{
      e.preventDefault();
      const id = btn.dataset.variant;
      btn.textContent='...';
      btn.disabled=true;
      try{
        await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:1})});
        btn.textContent='✓';
        btn.style.background='#00e887';
        setTimeout(()=>{ btn.textContent='+'; btn.style.background=''; btn.disabled=false; },1800);
      }catch(err){
        btn.textContent='!';
        setTimeout(()=>{ btn.textContent='+'; btn.disabled=false; },1500);
      }
    });
  });
}

// === INIT ===
document.addEventListener('DOMContentLoaded',()=>{
  initScrollReveal();
  initCounters();
  initFAQ();
  initParticles();
  initTilt();
  initStickyHeader();
  initQuickAdd();
});

})();
